export default `
  mutation updateAutomatedEmailSettings($input: AutomatedEmailSettingsInput!) {
    updateAutomatedEmailSettings(input: $input) {
      enabled
      senderEmail
      emailSubject
      emailBody
    }
  }
`
